<template>
    <div>
        <div class="row" style="margin-top: 1rem;">
            <div>
                <div style="text-align: center; width: 100%;">
                    <ul class="visual-check-legend">
                        <li><div class="circle circle-red"></div> Requires immediate attention</li>
                        <li><div class="circle circle-orange"></div> Advisory</li>
                        <li><div class="circle circle-green"></div> OK</li>
                        <li><div class="circle circle-grey"></div> Not Checked</li>
                    </ul>
                </div>
                <table class="table tyre-state-table" style="margin-top: 0;">
                <thead>
                    <tr>
                        <th style="width: 100px;"></th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">warning</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">priority_high</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">check</span>
                        </th>
                        <th style="font-size: 10px; vertical-align: middle;">
                            <span class="material-icons">remove</span>
                        </th>
                        <th style="width: 100px;">Pad Wear</th>
                        <th style="width: 300px;">Comments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Front</td>
                        <td @click="setFrontOutcome(AnswerOutcomes.OUTCOME_FAILED)" title="Failed">
                            <span class="circle" v-if="internalValue.additional_data.front_outcome === AnswerOutcomes.OUTCOME_FAILED"></span>
                        </td>
                        <td @click="setFrontOutcome(AnswerOutcomes.OUTCOME_ADVISORY)" title="Advisory">
                            <span class="circle" v-if="internalValue.additional_data.front_outcome === AnswerOutcomes.OUTCOME_ADVISORY"></span>
                        </td>
                        <td @click="setFrontOutcome(AnswerOutcomes.OUTCOME_PASSED)" title="Passed">
                            <span class="circle" v-if="internalValue.additional_data.front_outcome === AnswerOutcomes.OUTCOME_PASSED"></span>
                        </td>
                        <td @click="setFrontOutcome(AnswerOutcomes.OUTCOME_SKIPPED)" title="Skipped">
                            <span class="circle" v-if="internalValue.additional_data.front_outcome === AnswerOutcomes.OUTCOME_SKIPPED"></span>
                        </td>
                        <td style="padding: 0 1rem">
                            <div class="row">
                                <div class="col">
                                    <ui-textbox
                                        v-model="internalValue.additional_data.front_pads_wear_percentage"
                                        type="number"
                                        placeholder="0"
                                        @input="updated"
                                        @keydown="$emit('keydown')"
                                        :disabled="frontEntryDisabled"
                                    ></ui-textbox>
                                    <span style="font-size: 9px;">Remaining (Percent %)</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <ui-textbox
                                v-model="internalValue.additional_data.front_comments"
                                placeholder="None"
                                @input="updated"
                                style="text-align: left;"
                            ></ui-textbox>
                            <span style="font-size: 9px;">Report &amp;amp; Recommendations</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Rear</td>
                        <td @click="setRearOutcome(AnswerOutcomes.OUTCOME_FAILED)" title="Failed">
                            <span class="circle" v-if="internalValue.additional_data.rear_outcome === AnswerOutcomes.OUTCOME_FAILED"></span>
                        </td>
                        <td @click="setRearOutcome(AnswerOutcomes.OUTCOME_ADVISORY)" title="Advisory">
                            <span class="circle" v-if="internalValue.additional_data.rear_outcome === AnswerOutcomes.OUTCOME_ADVISORY"></span>
                        </td>
                        <td @click="setRearOutcome(AnswerOutcomes.OUTCOME_PASSED)" title="Passed">
                            <span class="circle" v-if="internalValue.additional_data.rear_outcome === AnswerOutcomes.OUTCOME_PASSED"></span>
                        </td>
                        <td @click="setRearOutcome(AnswerOutcomes.OUTCOME_SKIPPED)" title="Skipped">
                            <span class="circle" v-if="internalValue.additional_data.rear_outcome === AnswerOutcomes.OUTCOME_SKIPPED"></span>
                        </td>
                        <td style="padding: 0 1rem">
                            <div class="row">
                                <div class="col">
                                    <ui-textbox
                                        v-model="internalValue.additional_data.rear_pads_wear_percentage"
                                        type="number"
                                        placeholder="0"
                                        @input="updated"
                                        @keydown="$emit('keydown')"
                                        :disabled="rearEntryDisabled"
                                    ></ui-textbox>
                                    <span style="font-size: 9px;">Remaining (Percent %)</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <ui-textbox
                                v-model="internalValue.additional_data.rear_comments"
                                placeholder="None"
                                style="text-align: left;"
                            ></ui-textbox>
                            <span style="font-size: 9px;">Report &amp;amp; Recommendations</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    </div>
</template>

<script>
import {AnswerOutcomes, AnswerSchema, BrakeStateAnswerSchema} from "../../classes/Api/Inspection";
import {cloneDeep} from "lodash";

export default {
    props: {
        question: {
            type: Object,
            required: true,
        },
        answer: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            AnswerOutcomes,
            internalValue: null,
        }
    },
    created() {
        if (this.answer && this.answer.additional_data) {
            this.setInternalValue(this.answer)
        } else {
            this.setDefaultInternalValue()
        }
    },
    watch: {
        answer: {
            handler(n) {
                this.setInternalValue(n)
            },
            deep: true
        }
    },
    methods: {
        setInternalValue(value) {
            this.internalValue = cloneDeep(value)
        },
        setDefaultInternalValue() {
            this.setInternalValue(
                new AnswerSchema({
                    question_id: this.question.id,
                    additional_data: new BrakeStateAnswerSchema()
                })
            )
        },
        setFrontOutcome(outcome) {
            this.internalValue.additional_data.front_outcome = outcome

            this.updated()
        },
        setRearOutcome(outcome) {
            this.internalValue.additional_data.rear_outcome = outcome

            this.updated()
        },
        updated() {
            let outcomes = [
                this.internalValue.additional_data.front_outcome,
                this.internalValue.additional_data.rear_outcome
            ]

            if (outcomes.includes(AnswerOutcomes.OUTCOME_FAILED)) {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_FAILED
            } else if (outcomes.includes(AnswerOutcomes.OUTCOME_ADVISORY)) {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_ADVISORY
            } else {
                this.internalValue.outcome = AnswerOutcomes.OUTCOME_SKIPPED
            }

            this.$emit('input', cloneDeep(this.internalValue))
        }
    },
    computed: {
        frontEntryDisabled() {
            return this.internalValue.additional_data.front_outcome === AnswerOutcomes.OUTCOME_SKIPPED
        },
        rearEntryDisabled() {
            return this.internalValue.additional_data.rear_outcome === AnswerOutcomes.OUTCOME_SKIPPED
        }
    },
}
</script>

<style scoped>

</style>